import React, { Alert, AlertTitle, Typography, Grid, Button } from '@mui/material';
import { ErrorHandlerProps } from './ErrorHandlerProps';

export const ErrorHandler = ({ message }: ErrorHandlerProps) => {
	return (message ? <>
		<Alert severity='error'>
			<AlertTitle>Error</AlertTitle>
			<Typography variant='subtitle1'>An error has occured. Message:</Typography>
			<Typography variant='subtitle2'>{message}</Typography>
			<Typography variant='subtitle1'>Please refresh the page.</Typography>
		</Alert>
		<Grid container xs={12} textAlign={'center'}>
			<Grid item xs={12} pt={2}>
				<Button
					color='primary'
					variant='contained'
					onClick={() => {
						window.location.reload();
					}}
				>
					Refresh page
				</Button>
			</Grid>
		</Grid>
	</> : <></>);
};
